import { Directive, TemplateRef, input, contentChild } from '@angular/core';
import { DataTableFooterTemplateDirective } from './footer-template.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ngx-datatable-footer'
})
export class DatatableFooterDirective {
  readonly footerHeight = input<number>(undefined);
  readonly totalMessage = input<string>(undefined);
  readonly selectedMessage = input<string | boolean>(undefined);
  readonly pagerLeftArrowIcon = input<string>(undefined);
  readonly pagerRightArrowIcon = input<string>(undefined);
  readonly pagerPreviousIcon = input<string>(undefined);
  readonly pagerNextIcon = input<string>(undefined);

  readonly _templateInput = input<TemplateRef<unknown>>(undefined, { alias: 'template' });

  readonly _templateQuery = contentChild(DataTableFooterTemplateDirective, { read: TemplateRef });

  get template(): TemplateRef<unknown> {
    return this._templateInput() || this._templateQuery();
  }
}
